import React, { useState } from "react";

import { mdiPencil } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";
import { get, useFormContext } from "react-hook-form";

import FieldContainer from "./FieldContainer";

import type { ChangeEvent, JSX } from "react";

import type { InputProps } from "./types";

type AvatarInputProps = Pick<InputProps, "name" | "className" | "defaultValue">;

function AvatarInput({
  name,
  className,
  defaultValue,
}: AvatarInputProps): JSX.Element {
  const { watch, register, setValue } = useFormContext();
  const formValues = watch();

  const currentValue = get(formValues, name);

  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const { onBlur, onChange, ...rest } = register(name);

  const containerClassNames = classNames("!w-auto", className);

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const updatedValue = event.target.files?.[0];

    if (updatedValue) {
      setValue(name, updatedValue);
      setPreviewUrl(URL.createObjectURL(updatedValue));
    }
  };

  return (
    <FieldContainer className={containerClassNames}>
      <div
        className="border-border size-[7.5rem] min-w-fit flex-initial rounded-full border bg-cover bg-center"
        style={{ backgroundImage: `url(${previewUrl ?? currentValue})` }}
      >
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label
          className="flex size-full cursor-pointer items-center justify-center opacity-0 transition-opacity hover:opacity-100"
          htmlFor="image"
        >
          <Icon
            className="text-overlay-foreground"
            path={mdiPencil}
            size={1.25}
          />
        </label>
        <input
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...rest}
          accept="image/*"
          className="hidden"
          defaultValue={defaultValue}
          id="image"
          multiple={false}
          onChange={handleChange}
          type="file"
        />
      </div>
    </FieldContainer>
  );
}
export default AvatarInput;
